import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import CountyDryerVentCleaning from './blogs/Blog1';
import DryerVentCleaning from './blogs/Blog2';
import Header from './Header';

interface BlogPost {
  id: string;
  title: string;
  publishDate: string;
  component: React.FC;
}

const blogPosts: BlogPost[] = [
  {
    id: 'county-dryer-vent-cleaning',
    title: 'Annual Dryer Vent Cleaning Across the Portland Metro',
    publishDate: '2025-05-28',
    component: CountyDryerVentCleaning
  },
  {
    id: 'dryer-vent-cleaning-property-managers',
    title: 'Why Annual Dryer Vent Cleaning is a Must for Multi-Unit Property Managers in Portland',
    publishDate: '2025-05-28',
    component: DryerVentCleaning
  }
];

export const Blog = () => {
  return (
    <Box sx={{ py: { xs: 2, sm: 4 } }}>
      <Header />
      
      <Container maxWidth="lg">
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom 
          align="center" 
          color="primary"
          sx={{ mb: 6 }}
        >
          Blog Posts
        </Typography>

        <Box maxWidth="800px" mx="auto">
          <Grid container spacing={3}>
            {blogPosts.map((post) => (
              <Grid item xs={12} key={post.id}>
                <Box
                  component={Link}
                  to={`/blog/${post.id}`}
                  sx={{
                    textDecoration: 'none',
                    color: 'inherit',
                    display: 'block',
                    padding: '1.5rem',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.02)',
                      transform: 'translateY(-2px)'
                    }
                  }}
                >
                  <Typography 
                    variant="h5" 
                    gutterBottom
                    sx={{ 
                      fontWeight: 500,
                      lineHeight: 1.4
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ mt: 1 }}
                  >
                    {new Date(post.publishDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </Typography>
                </Box>
                <Box 
                  sx={{ 
                    height: '1px', 
                    bgcolor: 'rgba(0, 0, 0, 0.06)', 
                    my: 0.5
                  }} 
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export { blogPosts };
export default Blog;